import {cs} from "../../react/chain-services";
import {ScrollState} from "./scroll-state";
import {css, cx} from "emotion";
import * as React from "react";
import "./scroll-shadow.scss";
import {equalDeep} from "../../utils/objects";
import {getColorCodes} from "./color-codes";

export const ScrollShadow = ({color="black", direction, next}) => cs(
    ["directionMethods", (_, next) => next(directions[direction])],
    ["color", (_, next) => next(getColorCodes(color))],
    ["scrollState", ({directionMethods}, next) => ScrollState({
        compare: equalDeep,
        translate: (dom) => {
            const clientSize = directionMethods.getClientSize(dom);
            const scrollSize = directionMethods.getScrollSize(dom);

            if (clientSize === scrollSize) {
                return {};
            }
            const scrollOffset = directionMethods.getScrollOffset(dom);
            if (scrollOffset === 0) {
                return {end: true};
            }
            if (scrollOffset + clientSize >= scrollSize - 1) {
                return {start: true};
            }
            return {end: true, start: true};
        },
        next,
    })],

    ({scrollState, color}) => next({
        domRef: (dom) => scrollState.ref?.(dom),
        value: scrollState.value,
        render: (
            {
                // For horizontal
                width=15,
                paddingLeft=0, paddingBottom=0, widthLeft=undefined, widthRight=undefined,

                // For vertical
                height=50,

                opacity=0.05,
            }={}) => (
            <div
                className={cx(
                    "scroll-shadow-3dd",
                    direction,
                    scrollState.value,
                    direction === "horizontal" ? css`
                        --paddingLeft  : ${paddingLeft}px;
                        --paddingBottom: ${paddingBottom}px;
                        
                        --widthLeft : ${widthLeft  ?? width}px;
                        --widthRight: ${widthRight ?? width}px;
                    ` : css`
                        --height : ${height}px;
                    `,
                    css`
                        --opacity: ${opacity};
                        --color: ${color.join(",")};
                    `,
                )}
            />
        ),
    }),
);

const directions = {
    "horizontal": {
        getClientSize: (dom) => dom.clientWidth,
        getScrollSize: (dom) => dom.scrollWidth,
        getScrollOffset: (dom) => dom.scrollLeft,
    },
    "vertical": {
        getClientSize: (dom) => dom.clientHeight,
        getScrollSize: (dom) => dom.scrollHeight,
        getScrollOffset: (dom) => dom.scrollTop,
    },
};
